var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#858585",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 0C0.797333 0 0 0.797333 0 1.77778V14.2222C0 15.2027 0.797333 16 1.77778 16H7.66319H10.1458H14.2222C15.2027 16 16 15.2027 16 14.2222V1.77778C16 0.797333 15.2027 0 14.2222 0H1.77778ZM1.77778 1.77778H14.2222L14.224 14.2222H10.1458V10.6979H12.2483L12.5608 8.27604H10.1597V6.73264C10.1597 6.03219 10.3549 5.55903 11.3594 5.55903H12.6285V3.39757C12.0107 3.33446 11.3904 3.30378 10.7691 3.30556C8.92554 3.30556 7.66319 4.43075 7.66319 6.49653V8.27951H5.57986V10.7014H7.66319V14.2222H1.77778V1.77778Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSquare);
export default __webpack_public_path__ + "static/media/facebookSquare.1a7b7018.svg";
export { ForwardRef as ReactComponent };